export function clearMusicDownloadCounters(storage) {
  if (!storage) return 0

  const keys = []
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index)
    if (key?.startsWith('musicDownloadCounter_')) keys.push(key)
  }

  for (const key of keys) storage.removeItem(key)
  return keys.length
}

const OBS_HTML_REPAIR_MARKER = 'audioCacheRepair.obsHtml.v1'

export function runObsHtmlCacheRepairMigration(storage) {
  if (!storage || storage.getItem(OBS_HTML_REPAIR_MARKER) === 'done') return 0

  const cleared = clearMusicDownloadCounters(storage)
  storage.setItem(OBS_HTML_REPAIR_MARKER, 'done')
  return cleared
}
